<template>
  <section id="landing__brands" class="section">
    <div class="row justify-content-center" v-scroll-reveal>
      <div
        class="col-12 col-sm-6 col-md-4 d-flex align-items-center justify-content-center"
        v-for="brand in renderableTopBrands"
        :key="brand.id"
      >
        <div class="top-brand-container">
          <div>
            <a v-if="brand.websiteUrl" :href="brand.websiteUrl" target="_blank">
              <img
                :src="
                  `https://www.arctec.ie/static/img/brand/${brand.name.toLowerCase()}.jpg`
                "
                target="_blank"
                width="100%"
              />
            </a>
            <img
              v-else
              :src="
                brand.logoUrl || `https://www.arctec.ie/static/img/brand/${brand.name.toLowerCase()}.jpg`
              "
              width="100%"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  methods: mapActions(["fetchBrands"]),
  computed: {
    ...mapGetters(["brands", "topBrands"]),
    renderableTopBrands() {
      this.topBrands;
      return _.reduce(
        this.topBrands,
        (renderableBrands, topBrand) => {
          const brand = this.brands[topBrand.id];
          return brand ? [...renderableBrands, brand] : renderableBrands;
        },
        []
      );
    },
  },
  mounted() {
    this.fetchBrands();
  },
};
</script>

<style lang="scss">
.top-brand-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
